import "./index.css";
import { SettingsSidebar, SettingsSidebarItem } from "./SettingsSidebar";
import { Outlet, Navigate, useLocation } from "react-router";
import { getSidebarGroups, isPathAvailable } from "./sidebarGroups";
import { useAuth } from "@/Auth";
import { useMemo } from "react";
import { SvgIconType } from "@/svg";

function isPathItem(
  item: SettingsSidebarItem,
): item is { label: string; icon: SvgIconType; soon?: boolean; path: string } {
  return "path" in item;
}

export function Settings() {
  const auth = useAuth();
  const location = useLocation();
  const isRoot = Boolean(auth.isAuthenticated && auth.user?.is_root);

  const sidebarGroups = useMemo(() => {
    return getSidebarGroups(isRoot);
  }, [isRoot]);

  const firstAvailablePath = useMemo(
    () => sidebarGroups.flatMap((group) => group.items.filter(isPathItem))[0]?.path,
    [sidebarGroups],
  );

  const currentPath = location.pathname.split("/").pop();
  const isCurrentPathAvailable = isPathAvailable(currentPath, isRoot);

  if (firstAvailablePath && (location.pathname === "/settings" || !isCurrentPathAvailable)) {
    return (
      <Navigate to={`/settings/${firstAvailablePath}${location.search}${location.hash}`} replace />
    );
  }

  return (
    <div className="flex bg-lightGray h-full">
      <SettingsSidebar groups={sidebarGroups} />
      <div className="flex-1 h-full pl-10 pr-8 pt-6 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
